var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["recipients-tree", _vm.currentECircular.type] },
    [
      _c(
        "div",
        { class: ["root", { "collapse-root": !_vm.shouldExpand }] },
        [
          _c("i", {
            class: [
              "tree-arrow pointer",
              _vm.shouldExpand ? "fa-angle-down" : "fa-angle-right",
              "fa angle",
            ],
            on: { click: _vm.switchArrow },
          }),
          _vm._v(" "),
          _vm.isTenantEcircular
            ? [
                _c("span", { staticClass: "tree-zone" }, [
                  _vm._v(_vm._s(_vm.floors)),
                ]),
                _vm._v(" "),
                _vm.isViewOperation
                  ? _c("span", { staticClass: "tree-trade-name" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.list.tradeName || _vm.$t("emptyValue")) +
                          "\n      "
                      ),
                    ])
                  : _c("i", { staticClass: "tree-trade-name" }, [
                      _c(
                        "span",
                        {
                          staticClass: "pointer",
                          on: {
                            click: function ($event) {
                              return _vm.navToTenancy(_vm.list.id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.list.tradeName || _vm.$t("emptyValue")
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
                _vm._v(" "),
                _vm.showUserTypeCol
                  ? _c("span", { staticClass: "tree-contact-types" })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "tree-premises" }, [
                  _vm._v(_vm._s(_vm.premises)),
                ]),
                _vm._v(" "),
                _vm.showMarketingType
                  ? _c("span", { staticClass: "tree-marketing-type" })
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isVendorEcircular
            ? [
                _c("span", { staticClass: "tree-recipient-type" }, [
                  _vm._v("\n        " + _vm._s(_vm.list.id) + "\n      "),
                ]),
                _vm._v(" "),
                _vm.isViewOperation
                  ? _c("span", { staticClass: "tree-company-name" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.list.name || _vm.$t("emptyValue")) +
                          "\n      "
                      ),
                    ])
                  : _c("i", { staticClass: "tree-company-name" }, [
                      _c(
                        "span",
                        {
                          staticClass: "pointer",
                          on: {
                            click: function ($event) {
                              return _vm.navToVendor(_vm.list.id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.list.name || _vm.$t("emptyValue")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isTenancyEcircular
            ? [
                _c("span", { staticClass: "tree-recipient-type" }),
                _vm._v(" "),
                _vm.isViewOperation
                  ? _c("span", { staticClass: "tree-trade-name" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.list.tradeName || _vm.$t("emptyValue")) +
                          "\n      "
                      ),
                    ])
                  : _c("i", { staticClass: "tree-trade-name" }, [
                      _c(
                        "span",
                        {
                          staticClass: "pointer",
                          on: {
                            click: function ($event) {
                              return _vm.navToTenancy(_vm.list.id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.list.tradeName || _vm.$t("emptyValue")
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isAddOperation
            ? _c("i", {
                class: _vm.renderChooseIcon(_vm.list),
                on: { click: _vm.clickOneRoot },
              })
            : _vm.isDelOperation
            ? _c("i", {
                staticClass: "fa fa-times",
                on: { click: _vm._deleteOneRoot },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition-group",
        { attrs: { name: "expand-leaves", tag: "div" } },
        [
          _vm.shouldExpand
            ? _vm._l(_vm.recipients, function (leaf) {
                return _c(
                  "div",
                  {
                    key:
                      leaf.name + leaf.email + !!(leaf.roleType || []).length,
                    staticClass: "leaf",
                  },
                  [
                    _c("span", { staticClass: "tree-arrow-empty" }),
                    _vm._v(" "),
                    _vm.isTenantEcircular
                      ? _c("span", { staticClass: "tree-zone-empty" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTenancyEcircular
                      ? _c("span", { staticClass: "tree-recipient-type" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                leaf.primary
                                  ? _vm.$t("eCircular.recipientType.master")
                                  : _vm.$t("eCircular.recipientType.sub")
                              ) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class: _vm.isVendorEcircular
                          ? "tree-vendor-name"
                          : "tree-user-name",
                      },
                      [_vm._v(_vm._s(leaf.name))]
                    ),
                    _vm._v(" "),
                    _vm.showUserTypeCol
                      ? _c("span", { staticClass: "tree-contact-types" }, [
                          _vm._v(_vm._s(_vm.localUserContactTypes(leaf))),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "tree-email" }, [
                      _vm._v(_vm._s(leaf.email)),
                    ]),
                    _vm._v(" "),
                    _vm.showMarketingType
                      ? _c("span", { staticClass: "tree-marketing-type" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s((leaf.roleType || []).join(",")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isVendorEcircular
                      ? _c("span", { staticClass: "tree-recipient-type" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "eCircular.recipientType." + leaf.userType
                                )
                              ) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAddOperation
                      ? _c("i", {
                          class: _vm.renderChooseIcon(leaf),
                          on: {
                            click: function ($event) {
                              return _vm.clickLeaf(leaf)
                            },
                          },
                        })
                      : _vm.isDelOperation
                      ? _c("i", {
                          staticClass: "fa fa-times",
                          on: {
                            click: function ($event) {
                              return _vm._deleteOneLeaf(leaf)
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }